import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import LinkedContentNodeView from "./LinkedContentNodeView";

/**
 * LinkedContentNode 扩展
 * 支持在编辑器中展示链接内容，例如航班、附件、联系人、事件等
 */
export const LinkedContentNode = Node.create({
    name: "linkedContent",

    group: "block",

    atom: true, // 将节点作为一个整体处理

    draggable: true, // 可拖拽

    inline: false,

    selectable: true,

    // 定义节点属性
    addAttributes() {
        return {
            // 统一使用data属性存储JSON格式数据，包含type和实际内容
            data: {
                default: JSON.stringify({
                    type: "link",
                    data: {},
                }),
            },
            uniqueId: {
                default: null, // 用于标识和链接到侧边栏中的内容
            },
            displayParams: {
                default: JSON.stringify({
                    visible: true,
                    showDetails: false, // 是否显示详细信息
                    compact: false, // 是否使用紧凑模式
                    highlight: false, // 是否高亮显示
                }),
            },
        };
    },

    // 解析HTML时如何识别此节点类型
    parseHTML() {
        return [
            {
                tag: 'div[data-type="linked-content"]',
            },
        ];
    },

    // 渲染为HTML
    renderHTML({ HTMLAttributes }) {
        let contentData = {};
        try {
            contentData = JSON.parse(HTMLAttributes.data || "{}");
        } catch (e) {
            console.error("解析linkedContent数据失败:", e);
        }

        const contentType = contentData.type || "link";
        const uniqueId = HTMLAttributes.uniqueId || "";

        return [
            "div",
            {
                "data-type": "linked-content",
                "data-content-type": contentType,
                "data-unique-id": uniqueId,
                class: `linked-content-node ${contentType}`,
                ...HTMLAttributes,
            },
            0, // 不需要内容
        ];
    },

    // 使用自定义React组件渲染节点
    addNodeView() {
        return ReactNodeViewRenderer(LinkedContentNodeView);
    },

    // 命令工具栏点击时的行为
    addCommands() {
        return {
            insertLinkedContent:
                (options = {}) =>
                ({ chain }) => {
                    // 构建节点属性
                    const { data, uniqueId, displayParams } = options;

                    // 确保data是字符串形式
                    const dataString = typeof data === "string" ? data : JSON.stringify(data);

                    // 确保displayParams是字符串形式
                    const displayParamsString =
                        typeof displayParams === "string"
                            ? displayParams
                            : JSON.stringify(
                                  displayParams || {
                                      visible: true,
                                      showDetails: false,
                                      compact: false,
                                      highlight: false,
                                  },
                              );

                    return chain()
                        .insertContent({
                            type: this.name,
                            attrs: {
                                data: dataString,
                                uniqueId,
                                displayParams: displayParamsString,
                            },
                        })
                        .run();
                },
        };
    },
});

export default LinkedContentNode;
